<app-header-app xLink="/login"></app-header-app>
<app-form-template
  title="Új jelszó kérése"
  [submit]="sendEmail"
  [formGroup]="forgotPasswordForm"
>
  <payee-form-field width="wide">
    <span payee-label>Először is add meg az email címedet</span>
    <input
      payee-input
      formControlName="email"
      type="email"
      autocomplete="email"
      inputmode="email"
    />
    @if (email.dirty) {
      <ng-container payee-error>
        @if (email.hasError("email")) {
          <mat-error>Létező email címet adj meg</mat-error>
        }
        @if (email.hasError("required")) {
          <mat-error>A mező kitöltése kötelező</mat-error>
        }
      </ng-container>
    }
  </payee-form-field>

  <button
    payee-button
    width="wide"
    [disabled]="loading()"
  >
    @if (!loading()) {
      Új jelszót kérek
    }
    @if (loading()) {
      <div class="bw-theme flex hcenter">
        <mat-progress-spinner
          color="accent"
          mode="indeterminate"
          diameter="30"
        ></mat-progress-spinner>
      </div>
    }
  </button>
</app-form-template>
